export const Skeleton = {
  baseStyle: {},
  sizes: {},
  variants: {},
  defaultProps: {
    startColor: 'beta.500',
    endColor: 'beta.300',
  },
};
